import type { DocumentPageSchema } from '@avisoma/shared';

/**
 * UI offer for segmentation retry. Remaining refusals 409 from the server
 * guard (segmentation-retry.ts). Offer for error, segmented, or processing
 * stale ≥30 min (keep in sync with SEGMENTATION_RETRY_STALE_MS). Do not copy
 * wedge probes into the UI.
 */
const STALE_MS = 30 * 60 * 1000;

export function canRetrySegmentation(
  segmentation: DocumentPageSchema['processing']['segmentation'],
  now: Date = new Date(),
): boolean {
  if (!segmentation) return false;
  if (segmentation.status === 'error' || segmentation.status === 'segmented') return true;
  if (segmentation.status !== 'processing') return false;
  if (!segmentation.startedAt) return true;
  return now.getTime() - new Date(segmentation.startedAt).getTime() >= STALE_MS;
}
